import {HotMatchReducer, ReducerFromState} from "../../../@types/reducers";

export const getHotMatchesLength = (state: ReducerFromState<HotMatchReducer>): number => Object.keys(state.hotMatch.hotMatches).length;
